import React, { useEffect, useState } from 'react';
import columns from '../../../columns/tickets.jsx';
import { Form, Input, Select } from 'antd';
import ModalComponent from '../../../components/modals/ModalComponent.jsx';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import Pagination from '../../../components/pagination/Pagination.jsx';
import { AddSupportTicketApi, GetSupportTicketApi, GetSupportTicketPrioriytTypeApi, GetSupportTicketQueryTypeApi } from '../../../api/request/ib/support.js';
import { useSelector } from "react-redux";
import moment from 'moment';
import Eye from '../../../assets/Eye.jsx';
import { useNavigate } from 'react-router-dom';
import LoadableButton from '../../../components/buttons/LoadableButton.jsx';
import toast from 'react-hot-toast';
const { TextArea } = Input;

export default function Support() {

    const { userDetails } = useSelector((state) => state.user);
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [isAddTicketLoading, setIsAddTicketLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecord, setTotalRecord] = useState(0);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [queryOptions, setQueryOptions] = useState([]);
    const [priorityOptions, setPriorityOptions] = useState([]);
    const [data, setData] = useState([]);
    const [initialValues, setInitialValues] = useState({ title: '', ticketQueryId: null, description: '', priorityId: null });

    const getColor = (priority) => {
        switch (priority) {
            case 'High':
                return '#ef6464';
            case 'Medium':
                return '#e7c553';
            case 'Low':
                return '#2d9b63';
        }
    }

    const getTickets = async () => {
        try {
            setIsLoading(true);
            let params = {
                userId: userDetails?._id,
                UserType: 'ib',
                PageNumber: page,
                PageSize: pageSize,
                IsIb: true
            }
            const { data } = await GetSupportTicketApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(data?.data?.map((item) => {
                    return ({
                        ...item,
                        name: `${item?.firstName} ${item?.lastName}`,
                        createdAt: item?.createdDate ? moment(item?.createdDate).format('DD-MM-YYYY LT') : null,
                        priority: (<p className='uppercase font-bold text-sm' style={{ color: getColor(item?.priority) }}>{item?.priority}</p>),
                        status: (item?.status == 'Open' ? (<span className='px-3 py-1 rounded-full uppercase text-xs text-center success_tag'>{item?.status}</span>) : (<span className='uppercase px-3 py-1 rounded-full text-xs text-center fail_tag'>{item?.status}</span>)),
                        details: (<div className='cursor-pointer ' onClick={() => navigate(`/ib/view_ticket/${item?.ticketId}`)} src='/assets/icons/eye.svg' alt='icon' ><Eye /></div>),
                    })
                }));
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setData([]);
            setIsLoading(false);
        }
    }

    const getTicketQueryType = async () => {
        try {
            let params = {
                QueryType: 'ib'
            }
            const { data } = await GetSupportTicketQueryTypeApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setQueryOptions(data?.data?.map((item) => ({ ...item, value: item?.id, label: item?.queryName })));
            }
        } catch (error) { }
    }

    const getTicketPriorityType = async () => {
        try {
            const { data } = await GetSupportTicketPrioriytTypeApi();
            if (data?.success) {
                setPriorityOptions(data?.data?.map((item) => ({ ...item, value: item?.priorityId, label: item?.priorityName })));
            }
        } catch (error) { }
    }

    useEffect(() => {
        getTickets();
    }, [page, pageSize]);

    useEffect(() => {
        form.resetFields();
    }, [isOpenModal]);

    const openTicketForm = () => {
        getTicketQueryType();
        getTicketPriorityType();
        setIsOpenModal(true)
    }

    const handleSubmit = async (values) => {
        try {
            setIsAddTicketLoading(true);
            let params = {
                ticketUserType: 'IB',
                ...values,
            }
            const { data } = await AddSupportTicketApi(params);
            if (data?.success) {
                toast.success(data?.message);
                form.resetFields();
                getTickets();
                setIsOpenModal(false);
            }
            setIsAddTicketLoading(false);
        } catch (error) {
            if (error?.response?.data?.error?.message) {
                toast.error(error?.response?.data?.error?.message);
            }
            setIsAddTicketLoading(false);
        }
    }

    return (
        <div>
            <div className='border-[2px] border-light rounded-xl pt-4 w-full'>
                <div className='flex justify-between items-center px-4 lg:px-6 pb-4 border-b border-light'>
                    <p className='text-[#2F2B3D] text-xl font-semibold'>Ticket List</p>
                    {/* <button className='bg-primary text-sm text-white font-medium uppercase px-6 py-2 rounded-lg themeHover duration-500' onClick={openTicketForm}>Create Ticket</button> */}
                </div>
                <div className='my-6'>
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
                    <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
                </div>
            </div>

            {/* Add Ticket Modal */}
            <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title='Create Ticket' width={650}>
                <Form className='w-full' autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
                    <div className='input-white'>
                        <label className='text-base text-[#2F2B3DCC] font-medium'>Title</label>
                        <Form.Item name="title" rules={[{ required: true, message: 'Please enter ticket title.' }]}>
                            <Input placeholder="Title" className="mt-1 w-full ps-4 py-2" />
                        </Form.Item>
                    </div>
                    <div className='input-white mt-4'>
                        <label className='text-base text-[#2F2B3DCC] font-medium'>Description</label>
                        <Form.Item name="description" rules={[{ required: true, message: 'Please enter ticket description.' }]}>
                            <TextArea placeholder="Description" autoSize={{ minRows: 3, maxRows: 5 }} />
                        </Form.Item>
                    </div>
                    <div className='ant-select-selector-white mt-4'>
                        <label className='text-base text-[#2F2B3DCC] font-medium'>Query Type</label>
                        <Form.Item name="ticketQueryId" rules={[{ required: true, message: 'Please select a query name.' }]}>
                            <Select placeholder='Select query type' className='w-full mt-1' options={queryOptions} />
                        </Form.Item>
                    </div>
                    <div className='ant-select-selector-white mt-4'>
                        <label className='text-base text-[#2F2B3DCC] font-medium'>Priority Type</label>
                        <Form.Item name="priorityId" rules={[{ required: true, message: 'Please select a priority.' }]}>
                            <Select placeholder='Select priority' className='w-full mt-1' options={priorityOptions} />
                        </Form.Item>
                    </div>
                    <div className='mt-8'>
                        <LoadableButton
                            className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500'
                            disabled={isAddTicketLoading}
                            type="Submit"
                            lable='Save'
                            isLoading={isAddTicketLoading}
                            loadingLable='Adding ticket...'
                        />
                    </div>
                </Form>
            </ModalComponent>
        </div>
    )
}
